import React from "react";
import {
  PlaceholderWrapper,
  PlaceholderBar,
} from "./styles/FeaturesPlaceholder";

interface FeaturesPlaceholderProps {
  count?: number;
}

const FeaturesPlaceholder: React.FC<FeaturesPlaceholderProps> = ({
  count = 5,
}) => (
  <>
    {Array.from({ length: count }).map((_, idx) => (
      <PlaceholderWrapper key={idx}>
        <PlaceholderBar />
      </PlaceholderWrapper>
    ))}
  </>
);

export default FeaturesPlaceholder;
